/**
 * Recipient countries offered for Stripe Global Payouts bank refunds: the
 * subset of Stripe-supported countries payable with the local bank-transfer
 * capability our onboarding requests (wire-only countries are not offered
 * yet). ISO 3166-1 alpha-2, uppercase; the US stays first as the default.
 * https://docs.stripe.com/global-payouts/recipient-creation#requirements-for-supported-recipient-countries
 */
export const STRIPE_REFUND_RECIPIENT_COUNTRIES: readonly string[] = [
  "US",
  "AT",
  "AU",
  "BE",
  "BG",
  "BJ",
  "CA",
  "CH",
  "CI",
  "CR",
  "CY",
  "CZ",
  "DE",
  "DK",
  "DO",
  "EE",
  "ES",
  "FI",
  "FR",
  "GB",
  "GR",
  "HR",
  "HU",
  "ID",
  "IE",
  "IL",
  "IN",
  "IS",
  "IT",
  "JM",
  "LI",
  "LT",
  "LU",
  "LV",
  "MA",
  "MC",
  "MT",
  "MX",
  "NL",
  "NO",
  "NZ",
  "PE",
  "PL",
  "PT",
  "RO",
  "SE",
  "SG",
  "SI",
  "SK",
  "SM",
  "SN",
  "TN",
  "TT",
];

const COUNTRY_SET: ReadonlySet<string> = new Set(
  STRIPE_REFUND_RECIPIENT_COUNTRIES,
);

export function isStripeRefundRecipientCountry(
  value: unknown,
): value is string {
  return typeof value === "string" && COUNTRY_SET.has(value);
}
